export default __webpack_public_path__ + "static/tile_desktop-0294ae143406fb24863a87b28c396f2f.png";